export default __webpack_public_path__ + "static/media/user.b2dae56f.svg";